// Every number shown in the app uses "." as the decimal separator and a
// (narrow, non-breaking) space between thousands, whatever the browser locale.
export function formatDecimal(value, minDecimals = 2, maxDecimals = minDecimals) {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals,
  })
    .format(value)
    .replace(/,/g, " ");
}
